import type { CallContractResponse } from '@/src/services/walletService';
import walletStore from '@/src/stores/walletStore';
import walletMessageChannel from '../walletMessageChannel';

export type CallContractTx = {
  chainId: number;
  contractAddress: string;
  method: string;
  params: unknown[];
};

export type CallContractHandler = (
  tx: CallContractTx
) => Promise<CallContractResponse>;

export const onCallContract: CallContractHandler = (tx) => {
  return new Promise<CallContractResponse>((resolve, reject) => {
    walletStore.setState({
      request: {
        type: 'callContract',
        ...tx,
      },
    });
    walletMessageChannel.callContractResolve = resolve;
    walletMessageChannel.requestReject = reject;
  });
};
